/**
 * Utility functions for team names
 */

/**
 * Remove common suffixes like "FC", "AFC", "CF" from team names
 * @param teamName The full team name
 * @returns The cleaned team name
 */
export const cleanTeamName = (teamName: string): string => {
  // Remove common football club suffixes
  return teamName
    .replace(/\s+(FC|F\.C\.|AFC|A\.F\.C\.|CF|C\.F\.|SC|S\.C\.|AC|A\.C\.|BC|B\.C\.)$/i, '')
    .trim();
};

/**
 * Create a match name from two teams
 * @param homeTeam Home team name
 * @param awayTeam Away team name
 * @returns Formatted match name
 */
export const createMatchName = (homeTeam: string, awayTeam: string): string => {
  return `${cleanTeamName(homeTeam)} vs ${cleanTeamName(awayTeam)}`;
};